import React, { ReactNode } from "react";
import "./Notification.css";

type NotificationProps = {
  readonly type: "success" | "error";
  readonly title?: string;
  readonly children?: ReactNode | string | false;
};

function Notification({ children, type, title }: NotificationProps) {
  if (!children) {
    return null;
  }

  return (
    <div className={`notification-wrapper ${type}-wrapper`}>
      {title && <h5>{title}</h5>}
      <div className="notification-message">{children}</div>
    </div>
  );
}

export default Notification;
